import React, { useState, useRef, useEffect } from 'react';
import { FiMessageCircle, FiChevronDown, FiShoppingBag } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const AppHeader = ({ stats, configured }) => {
  const [showKPIs, setShowKPIs] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    if (!showKPIs) return;
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowKPIs(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [showKPIs]);

  return (
    <div className="bg-white border-b border-neutral-200 shadow-soft">
      <div className="w-full max-w-[1850px] mx-auto px-6 lg:px-10 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center shadow-medium">
              <FiMessageCircle className="w-6 h-6 text-white" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-neutral-900">Vardaan WhatsApp</h1>
              <p className="text-sm text-neutral-500">Cloud API messaging &amp; conversations</p>
            </div>
          </div>
          {configured !== false && stats && (
            <div className="flex items-center gap-3">
              <Link
                to="/ecommerce"
                className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-neutral-200 bg-white text-sm font-semibold text-neutral-700 hover:bg-neutral-50 transition-colors shadow-soft"
              >
                <FiShoppingBag className="w-4 h-4 text-emerald-600" />
                Ecommerce
              </Link>
              <div className="relative" ref={dropdownRef}>
              <button
                type="button"
                onClick={() => setShowKPIs((v) => !v)}
                className="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-neutral-200 bg-white text-sm font-semibold text-neutral-700 hover:bg-neutral-50 transition-colors shadow-soft"
              >
                <FiChevronDown className={`w-4 h-4 transition-transform ${showKPIs ? '' : '-rotate-90'}`} />
                Stats
              </button>
              {showKPIs && (
                <div className="absolute right-0 top-full mt-2 z-50 bg-white rounded-xl border border-neutral-200 shadow-2xl p-5 w-[480px] max-w-[calc(100vw-3rem)]">
                  {stats.blockedCount > 0 && (
                    <div className="mb-4 p-3 rounded-lg border border-amber-200 bg-amber-50 text-amber-900 text-xs flex items-start gap-2">
                      <span className="font-semibold shrink-0">Blocked:</span>
                      <span>
                        {stats.blockedCount} message{stats.blockedCount === 1 ? '' : 's'} could not be delivered.
                      </span>
                    </div>
                  )}
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                    <div className="bg-neutral-50 rounded-lg border border-neutral-200 px-3 py-2.5">
                      <div className="text-[11px] text-neutral-500 mb-0.5">Conversations</div>
                      <div className="text-lg font-bold text-neutral-900">{stats.totalConversations || 0}</div>
                    </div>
                    <div className="bg-neutral-50 rounded-lg border border-neutral-200 px-3 py-2.5">
                      <div className="text-[11px] text-neutral-500 mb-0.5">Sent (24h)</div>
                      <div className="text-lg font-bold text-neutral-900">{stats.last24hOutbound || 0}</div>
                    </div>
                    <div className="bg-neutral-50 rounded-lg border border-neutral-200 px-3 py-2.5">
                      <div className="text-[11px] text-neutral-500 mb-0.5">Delivered</div>
                      <div className="text-lg font-bold text-emerald-600">{stats.deliveredCount || 0}</div>
                    </div>
                    <div className="bg-neutral-50 rounded-lg border border-neutral-200 px-3 py-2.5">
                      <div className="text-[11px] text-neutral-500 mb-0.5">Read</div>
                      <div className="text-lg font-bold text-sky-600">{stats.readCount || 0}</div>
                    </div>
                    <div className="bg-neutral-50 rounded-lg border border-neutral-200 px-3 py-2.5">
                      <div className="text-[11px] text-neutral-500 mb-0.5">Pending</div>
                      <div className="text-lg font-bold text-amber-600">{stats.pendingCount || 0}</div>
                    </div>
                    <div className="bg-neutral-50 rounded-lg border border-neutral-200 px-3 py-2.5">
                      <div className="text-[11px] text-neutral-500 mb-0.5">Failed</div>
                      <div className="text-lg font-bold text-red-600">{stats.failedCount || 0}</div>
                    </div>
                    <div className="bg-neutral-50 rounded-lg border border-neutral-200 px-3 py-2.5 col-span-2">
                      <div className="text-[11px] text-neutral-500 mb-0.5">Delivery Rate</div>
                      <div className="text-lg font-bold text-emerald-600">{stats.deliveryRate || 0}%</div>
                    </div>
                  </div>
                </div>
              )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppHeader;
